import { render, staticRenderFns } from "./CotPuaListPage.vue?vue&type=template&id=402c0883"
import script from "./CotPuaListPage.vue?vue&type=script&lang=js"
export * from "./CotPuaListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports